/*
 * Build flag for the WAIVER SIGNING SNAPSHOT receipt (design DESIGN-MY-WAIVER-
 * SIGNING-SNAPSHOT-V1, boardroom-accepted Tier B). Same shape as
 * teenSelfHolderEnabled:
 *
 *   VITE_WAIVER_SNAPSHOT_RECEIPT_ENABLED === 'true' → the waiver receipt and
 *     "Download signed copy" read my-api's GET waiver-record?view=snapshot and
 *     render ONLY from the stored signing snapshot (legacy rows: labelled
 *     "reconstructed" when the template is unchanged, refused when it
 *     changed); the guardian declaration is mapped and rendered; the waiver
 *     submit carries declinedSections and the guardian sign carries
 *     template_hash. Absent or anything else = OFF: every surface is exactly
 *     as before.
 *
 * The env is injectable so tests can pin both sides.
 */
export function waiverSnapshotReceiptEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_WAIVER_SNAPSHOT_RECEIPT_ENABLED === 'true'
}
